module.exports = __webpack_public_path__ + "static/media/iterations.17280051.gif";